import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
// root page
import App from './pages/app';
// worker and vitals
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// providers
import { UserDataProvider } from './hooks/useUserData';
import { hotjar } from 'react-hotjar';
import { ThemeProvider } from '@mui/material';

// theme
import { theme } from 'styles/theme';
// styles
import './index.css';
import 'fonts/stylesheet.css';
import { getRuntime } from 'utils/getRuntime';
import TagManager from 'react-gtm-module';
import { initConsentMode } from 'utils/consent';

if (getRuntime() === 'prod') {
  initConsentMode();
  hotjar.initialize({ id: 3476046, sv: 6 });
  ReactGA.initialize('G-QB6N736PFH');
  if (process.env.REACT_APP_GTM_ID) {
    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
  }
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <UserDataProvider>
        <App />
      </UserDataProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
